import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LogService } from 'app/_services/logmanager.service';

@Injectable()
export class LoginControl {

    // Observable string sources
    public isloggedin = new Subject<boolean>();
    public checkedsession = new Subject<boolean>();
    public checkedsecretaria = new Subject<boolean>();

    // Service message commands
    setloggedin(newstate: boolean) {
        LogService.log('LoginControlService' , 'setloggedin ' + newstate);
        this.isloggedin.next(newstate);
    }

    setcheckedsession(newstate: boolean) {
        LogService.log('LoginControlService' , 'setcheckedsession ' + newstate);
        this.checkedsession.next(newstate);
    }

    setcheckedsecretaria(newstate: boolean) {
        LogService.log('LoginControlService' , 'checkedsecretaria ' + newstate);
        this.checkedsecretaria.next(newstate);
    }
}
